import userTicketTracking from './useTicketTracking';
import useRegistrationTracking from './useRegistrationTracking';
import useCustomizationTracking from './useCustomizationTracking';
import useProtectionTracking from './useProtectionTracking';
import usePaymentTracking from './usePaymentTracking';
import useSuccessTracking from './useSuccessTracking';
import useGlobalTracking from './useGlobalTracking';
import use3DsTracking from './use3DsTracking';

export default function useUserTracking() {
  return {
    ...useGlobalTracking(),
    ...userTicketTracking(),
    ...useRegistrationTracking(),
    ...useCustomizationTracking(),
    ...useProtectionTracking(),
    ...usePaymentTracking(),
    ...useSuccessTracking(),
    ...use3DsTracking(),
  };
}
